<template>
  <p>
    {{ i18n(translations.activeMarketsLabel) }}<br />
    <span class="flex flex-wrap gap-6">
      <RevTag
        :label="
          i18n(translations.activeMarketsTag, {
            weekday: getWeekday('SATURDAY'),
            activeMarkets: saturdayActiveMarkets.activeMarkets,
            totalMarkets: saturdayActiveMarkets.totalMarkets,
          })
        "
        variant="secondary"
      />
      <RevTag
        :label="
          i18n(translations.activeMarketsTag, {
            weekday: getWeekday('SUNDAY'),
            activeMarkets: sundayActiveMarkets.activeMarkets,
            totalMarkets: sundayActiveMarkets.totalMarkets,
          })
        "
        variant="secondary"
      />
    </span>
  </p>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTag } from '@ds/components/Tag'

import { useGetWeekday } from '../../../../composables/useGetWeekday'

import translations from './ActiveMarkets.translations'
import type { ActiveMarketsProps, MarketCoverage } from './ActiveMarkets.types'

const i18n = useI18n()

const { weekendDeliveryConfigurations } = defineProps<ActiveMarketsProps>()
const getWeekday = useGetWeekday()

const saturdayActiveMarkets = computed<MarketCoverage>(() => {
  const saturdayDeliveryConfigurations = weekendDeliveryConfigurations.filter(
    ({ day }) => day === 'SATURDAY',
  )

  return {
    activeMarkets: new Set(
      saturdayDeliveryConfigurations
        .filter(({ workingDay }) => workingDay)
        .flatMap(({ countryCode }) => countryCode),
    ).size,
    totalMarkets: new Set(
      saturdayDeliveryConfigurations.flatMap(({ countryCode }) => countryCode),
    ).size,
  }
})

const sundayActiveMarkets = computed<MarketCoverage>(() => {
  const sundayDeliveryConfigurations = weekendDeliveryConfigurations.filter(
    ({ day }) => day === 'SUNDAY',
  )

  return {
    activeMarkets: new Set(
      sundayDeliveryConfigurations
        .filter(({ workingDay }) => workingDay)
        .flatMap(({ countryCode }) => countryCode),
    ).size,
    totalMarkets: new Set(
      sundayDeliveryConfigurations.flatMap(({ countryCode }) => countryCode),
    ).size,
  }
})
</script>
